import { FaturaRowV2 } from "../FaturaRowV2";
import { PaginationV2 } from "../../Atoms/PaginationV2";
import { useInvoicesScheduleV2 } from "./useInvoicesScheduleV2";

export const InvoicesScheduleV2 = () => {
  const { faturas, pagination, setNumberPage, acessarFatura } =
    useInvoicesScheduleV2();

  return (
    <div className="flex w-full flex-col gap-6">
      {faturas.length > 0 ? (
        <div className="flex flex-col gap-6">
          {faturas.map((fatura, index) => (
            <FaturaRowV2
              key={fatura.idReferencia ?? index}
              fatura={fatura}
              isOdd={index % 2 === 0}
              onVerFatura={acessarFatura}
            />
          ))}
        </div>
      ) : (
        <p className="text-sm text-[#2d2d2d]">Nenhuma fatura encontrada</p>
      )}

      {faturas.length > 0 && (
        <PaginationV2
          className="mx-auto"
          totalPage={pagination.totalPage}
          totalRegister={pagination.totalRegister}
          actualPage={pagination.actualPage}
          setNumberPage={setNumberPage}
        />
      )}
    </div>
  );
};
